import { render, staticRenderFns } from "./colorForm.vue?vue&type=template&id=743faa74&scoped=true&"
import script from "./colorForm.vue?vue&type=script&lang=js&"
export * from "./colorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743faa74",
  null
  
)

export default component.exports